import React from 'react';

interface ImageModalProps {
  isOpen: boolean;
  onClose: () => void;
  imageUrl: string;
  alt: string;
}

const ImageModal = ({ isOpen, onClose, imageUrl, alt }: ImageModalProps) => {
  const handleClose = (e: React.MouseEvent<HTMLDivElement>) => {
    // 点击模态框背景时关闭
    if (e.currentTarget === e.target) {
      onClose();
    }
  };

  return (
    isOpen && (
      <div
        className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center"
        onClick={handleClose}
        role="dialog"
        aria-modal="true"
      >
        <div className="bg-white rounded-lg p-4 max-w-4xl w-full max-h-[90vh] overflow-auto">
          <div className="flex justify-end mb-2">
            <button
              className="text-gray-500 hover:text-gray-700 focus:outline-none"
              onClick={onClose}
            >
              <span className="text-xl">&times;</span>
            </button>
          </div>
          <img
            src={imageUrl}
            alt={alt}
            className="w-full h-auto object-contain max-h-[80vh]"
            onContextMenu={(e) => e.preventDefault()}
          />
        </div>
      </div>
    )
  );
};

export default ImageModal;
